import React from 'react';
import CarouselComponent from '../../Carousel/Carousel';
import AnimatedRoute from '../../AnimatedRoute/AnimatedRoute'


function Home() {
  return (
    <AnimatedRoute>
          <CarouselComponent/>
    </AnimatedRoute>
  )
}

export default Home;